// extracted by mini-css-extract-plugin
export default {"scroll":"InfinitTxtLoop_scroll__gepPv","scrollAnime":"InfinitTxtLoop_scrollAnime__KgdBQ","electro":"InfinitTxtLoop_electro__gOuV3","fixed":"InfinitTxtLoop_fixed__NgpEp"};